import React, { FC } from 'react';

const NotFound: FC = () => {
	return <>Page not found!</>;
};

export default NotFound;
